
import login from './pages/login'
import register from './pages/register'
import modules from './pages/modules'
import privacyPlocy from './pages/privacyPlocy'
import userAgreement from './pages/userAgreement'


import home from './pages/home'
const pageRouters = [
  login,
  modules,
  register,
  privacyPlocy,
  home,
  userAgreement
]

export default pageRouters
